// ** Reducers Imports
import navbar from "./navbar";
import layout from "./layout";
import auth from "./authentication";
import currency from "./currency";
import KYC from "./KYC";
import wallet from "./wallet";
import user from "./user";
import profile from "./profile";
import notification from "./notification";
import online from "./onlineData";
import bankCard from "./bankCard";
import websocket from "./websocket";
import { modalPersistenceReducer } from "../hooks/useModalPersistence";

const rootReducer = {
  auth,
  navbar,
  layout,
  currency,
  KYC,
  wallet,
  user,
  profile,
  notification,
  online,
  bankCard,
  websocket,
  modalPersistence: modalPersistenceReducer,
};

export default rootReducer;
